import type { ComponentPropsWithoutRef } from 'react'

import { cn } from '@/lib/cn'

export function PageContentBoundary({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('mx-auto w-full', className)} {...props} />
}
